import React from 'react';
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import { Textbox } from "react-inputs-validation";
import DatosAsegurado from './DatosAsegurado';
import { formatearNumero } from "../utils/parsearNumeros";

const RenovacionVehiculos = ({
    dataRenovacion,
    obtenerNombreODenominacion,
    obtenerEdad,
    onClickAtras
}) => {
    return (
        <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
            <DatosAsegurado
                dataRenovacion={dataRenovacion}
                obtenerNombreODenominacion={obtenerNombreODenominacion}
                obtenerEdad={obtenerEdad}
            />

            {dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reDatosVehiculo && dataRenovacion.reDatosProducto.reDatosVehiculo.map((vehiculo, index) => (
                <Card className="flex-row" key={index}>
                    <CardBody>
                        <h4 style={{ fontWeight: "bold" }}>Datos del Vehículo {index + 1}</h4>
                        <p />
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.rePlaca}
                                />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Marca</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.reMarca}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Modelo</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.reModelo}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Color</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.reColorTxt}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Motor</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.reMotor}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Chasis</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.reChasis}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Año</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={vehiculo.reAño}
                                />
                            </Col>
                        </Row>
                        {vehiculo.reProductoOriginal && (
                            <Row>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                    <h5 style={{ fontWeight: "bold" }}>Producto actual</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                    <Textbox
                                        classNameInput="input-type-label form-control"
                                        value={vehiculo.reProductoOriginal}
                                    />
                                </Col>
                            </Row>
                        )}
                        {vehiculo.reProducto && (
                            <Row>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                    <h5 style={{ fontWeight: "bold" }}>Producto a renovar</h5>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                    <Textbox
                                        classNameInput="input-type-label form-control"
                                        value={vehiculo.reProducto}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Suma asegurada anterior</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={`$${formatearNumero(vehiculo.reValorAsegurado)}`}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            ))}

            {dataRenovacion.reDatosConductor && (
                <Card className="flex-row">
                    <CardBody>
                        <h4 style={{ fontWeight: "bold" }}>Datos del Conductor</h4>
                        <p />
                        <Row>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Identificación</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={dataRenovacion.reDatosConductor.reIdentificacion}
                                />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Nombre Completo</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={`${dataRenovacion.reDatosConductor.reNombre1} ${dataRenovacion.reDatosConductor.reApellido1}`}
                                />
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <h5 style={{ fontWeight: "bold" }}>Dirección</h5>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                                <Textbox
                                    classNameInput="input-type-label form-control"
                                    value={dataRenovacion.reDatosConductor.reDireccion}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            )}

            <Card className="flex-row">
                <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>Datos del Producto</h4>
                    <p />
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Producto</h5>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <Textbox
                                classNameInput="input-type-label form-control"
                                value={dataRenovacion.polDescripcionSeguroVer}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <Button
                className="btn btn-primary"
                onClick={onClickAtras}
                style={{ display: "block", margin: "0", marginBottom: 20 }}>
                <i className='fa fa-chevron-circle-left' aria-hidden='true' />{" "}
                {"ATRÁS"}
            </Button>
        </Col>
    );
};

export default RenovacionVehiculos;
